@if (isAvailable$ | async) {
  <button
    type="button"
    class="visual-guide-button"
    matTooltip="Uruchom przewodnik tej strony"
    aria-label="Uruchom przewodnik tej strony"
    [disabled]="disabled"
    (click)="startGuide()"
    >
    <mat-icon aria-hidden="true">smart_display</mat-icon>
  </button>
}
